import type { ReactNode } from 'react';
import { ProgressBar } from './progressBar';
import { SegmentedProgressBar } from './segmentedProgressBar';

type Segment = { flex: number; color: string };

type Props = {
  label: ReactNode;
  value: ReactNode;
  barPercent: number;
  barColor?: string;
  segments?: Segment[];
  footer?: ReactNode;
};

export function ProgressItem({ label, value, barPercent, barColor, segments, footer }: Props) {
  return (
    <div>
      <div className="flex items-baseline justify-between mb-[7px]">
        <span className="text-base text-gray-500 font-medium">{label}</span>
        <span className="text-base">{value}</span>
      </div>
      {segments ? (
        <SegmentedProgressBar segments={segments} totalPercent={barPercent} />
      ) : (
        <ProgressBar percent={barPercent} color={barColor ?? ''} />
      )}
      {footer}
    </div>
  );
}
